class AdvertEditPageController {

  constructor(AdvertService, LoaderService, AlertService, Upload, $stateParams, $state) {
    this.AdvertService = AdvertService;
    this.LoaderService = LoaderService;
    this.AlertService = AlertService;
    this.Upload = Upload;
    this.$stateParams = $stateParams;
    this.$state = $state;
  }

  $onInit() {
        var self = this;
        self.files = [];
        self.linkValues = {};
      self.validation = {};
        self.countFileUploaded = 0;
        self.imageEndpoint = "/api/upload";
        self.advertId = self.$stateParams.advertId;
        self.advert.type = self.$stateParams.advertType;
        self.returnSuccessState = self.$stateParams.returnSuccessState ? self.$stateParams.returnSuccessState : 'app.advertising.feature';
        if(self.advert.linkType){
            if(self.advert.linkType.name === 'external'){
              self.linkValues.external = self.advert.linkValue;
            }
            if(self.advert.linkType.name === 'raceday'){
              self.linkValues.raceday = self.advert.linkValue;
            }
            if(self.advert.linkType.name === 'internal'){
              self.linkValues.internal = self.advert.linkValue;
            }
            if(self.advert.linkType.name === 'location'){
                self.linkValues.location = self.advert.linkValue;
            }
            if(self.advert.linkType.name === 'non_racing_event'){
                self.linkValues.non_racing_event = self.advert.linkValue;
            }
        }

  }

  storeFile(picFile) {
    this.files[0] = picFile;
  }

  save() {
    var self = this;

      if(!self.validForm()){
          self.AlertService.error("The form has validation errors.");
          return;
      }

    self.LoaderService.start();
      return self.AdvertService.processLinkTypes(self.advert, self.linkValues)
          .then(function(advert){

              //self.advert = advert;
              self.LoaderService.start();
              return self.AdvertService.update(advert, self.files[0])
                  .then(() => {
                      // empty the file array
                      self.files.splice(0, self.files.length);
                          self.AlertService.success("Advert has been updated");
                          self.$state.go(self.returnSuccessState);
                      }
                  )
                  .catch((error) => {
                      if(error.type === 'image'){
                          self.validation = {};
                          self.validation.bannerImage = error.message;
                          self.AlertService.error("The form has validation errors.");
                          // empty the file array
                          self.files.splice(0, self.files.length);
                      }
                      else{
                          self.AlertService.error("There was a problem saving the Advert");
                      }

                  })
                  .finally(()=> {
                      self.LoaderService.stop();
                  });
      });
  }

    deleteAdvert(advertId) {
        if ( confirm("Are you sure? This cannot be undone.") ) {
          var self = this;
          self.LoaderService.start();
          self.AdvertService.deleteAdvert(advertId)
              .then( () => {
                  self.AlertService.success("Advert has been deleted");
                  self.$state.go('app.advertising.feature');
              })
              .catch( (error) => self.AlertService.error('There was an error deleting this advert') )
              .finally( () => self.LoaderService.stop());
        }
    }

    validForm() {
        var self = this;
        //validation

        self.validation = {};

        if(self.advert.title === undefined || self.advert.title === ''){
            self.validation.name = 'Name is required';
        }
        if(self.advert.type == 2 && (self.advert.socialCategory === null || self.advert.socialCategory === undefined)){
            this.validation.socialCategory = 'Social Category is required';
        }
        if(self.advert.linkType === null || self.advert.linkType === undefined){
            this.validation.link = 'Link Type is required';
        }

        if(self.isEmpty(self.validation)){
            return true;
        }
        else{
            return false;
        }

    }

    isEmpty(obj) {

        // null and undefined are "empty"
        if (obj == null) return true;

        // Assume if it has a length property with a non-zero value
        // that that property is correct.
        if (obj.length > 0)    return false;
        if (obj.length === 0)  return true;

        // If it isn't an object at this point
        // it is empty, but it can't be anything *but* empty
        // Is it empty?  Depends on your application.
        if (typeof obj !== "object") return true;

        // Otherwise, does it have any properties of its own?
        // Note that this doesn't handle
        // toString and valueOf enumeration bugs in IE < 9
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) return false;
        }

        return true;
    }

}
AdvertEditPageController.$inject = ['AdvertService', 'LoaderService', 'AlertService', 'Upload', '$stateParams', '$state'];

export default AdvertEditPageController;
